import React, { useContext, useEffect, useState } from "react";
import { TbInfoCircle } from "react-icons/tb";
import { DashboardContext } from "../../contexts/Dashboard/DashboardContext";
import Clickable from "../../pages/Dashboard/Clickable";
import TitleComponent from "../TitleComponent";
import TooltipConfig from "../Tooltip";

const HeaderComponent = ({
  title,
  clickable,
  id,
  width,
  rightContent,
}: {
  title: string;
  clickable?: boolean;
  id: string;
  width?: number;
  rightContent?: React.ReactNode;
}) => {
  const { dataComponents, getSizesComponent } = useContext(DashboardContext);
  const [widthComponent, setWidthComponent] = useState(300);

  function transformId(idGraph: string): string {
    const parts = idGraph.split("-");
    const capitalized = parts.map((part, index) =>
      index === 0 ? part : part.charAt(0).toUpperCase() + part.slice(1)
    );
    return capitalized.join("");
  }

  const tooltipText = dataComponents
    .filter(function (value) {
      return value.id === transformId(id);
    })[0]
    .description.split("\\n");

  useEffect(() => {
    if (width) {
      setWidthComponent(width);
    } else {
      const sizes = getSizesComponent({
        id: id,
      });
      setWidthComponent(sizes.width);
    }
  }, [width]);

  return (
    <div>
      <div
        className="display-flex-space-between"
        style={{ padding: "15px 20px 0px 20px", maxWidth: widthComponent }}
      >
        <div style={{ display: "inline-flex", width: widthComponent }}>
          <div style={{ height: "25px" }}>
            <TooltipConfig
              content={tooltipText}
              children={<TbInfoCircle />}
              style={true}
            />
          </div>
          <TitleComponent title={title} width={widthComponent} />
        </div>
        {rightContent ?? (clickable ? <Clickable /> : <div />)}
      </div>
    </div>
  );
};

export default HeaderComponent;
